
<div class="flex_col" style="user-select: none; max-width: 100%; width: 100%;">
  <div id="label_container" class="flex_row pl-3" *ngIf="labels?.length">
    <div class="label" *ngFor="let label of labels">
      <div class="color_circle" [style.background-color]="label.color"></div>
      <div style="margin: auto;">
        {{label.description}}
      </div>
    </div>
  </div>
  <div style="width: 100%; overflow-x: auto;">
    <div style="width: fit-content; position: relative;">
      <div style="width: fit-content; overflow-x: auto;position: relative; border: 1px solid lightgray; border-radius: 4px;" class="flex_col">
        <mat-expansion-panel *ngIf="options.length" style="margin: 1px;" [togglePosition]="'before'">
          <mat-expansion-panel-header>
            <mat-panel-title> Optionen </mat-panel-title>
            <div style="margin: auto 6px auto auto; padding: 4px 0;" (click)="$event.stopPropagation()">
              <div class="flex_row" style="width: fit-content; flex-wrap: nowrap; font-weight: normal;">
                <div style="border-right: 1px solid black; margin-right: 4px;">
                  <div class="fast_filter"
                       [ngClass]="activeFilter == '' ? 'selected' : ''"
                       [style.color]="'black'"
                       [style.background-color]="'white'"
                       (click)="activeFilter = ''"
                  >
                    <div style="margin: auto 0; display: inline-flex; flex-direction: row;">
                      Alle
                    </div>
                  </div>
                </div>
                <div class="fast_filter"
                     *ngFor="let filter of filter"
                     [ngClass]="activeFilter == filter ? 'selected' : ''"
                     [style.color]="'black'"
                     [style.background-color]="'white'"
                     (click)="activeFilter = filter"
                >
                  <div style="margin: auto 0; display: inline-flex; flex-direction: row;">
                    {{filter}}
                    ({{getFilterInstanceAmount(filter)}})
                  </div>
                </div>
              </div>
            </div>
          </mat-expansion-panel-header>
          <table>
            <tbody>
              <tr *ngFor="let option of options" style="border-top: 1px solid lightgray">
                <td style="max-width: 160px; min-width: 160px; font-size: .9rem;">
                  {{option.title}}
                  <fa-icon *ngIf="option.tooltip" [icon]="faInfoCircle" [tooltip]="option.tooltip"></fa-icon>
                </td>
                <ng-container *ngFor="let bar of bars">
                  <td *ngIf="barIsShown(bar)" style="max-width: 48px; min-width: 48px; text-align: center;">
                    <mat-checkbox color="primary" [(ngModel)]="bar.data.options[option.title]" (change)="changeOptionEvent.emit({idx: bar.data.external_idx || bars.indexOf(bar), option: option.title, new_value: $event.checked})"></mat-checkbox>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
        <div class="bars-scroll-wrapper" #barsScrollWrapper>
        <div id="bars_container" class="flex_row" [style.height.px]="barsContainerHeightPx">
          <div id="bars_container_overlay"></div>
          <div style="position: relative; min-height: 100px; width: 50px; overflow-y: visible; border-right: 1px solid lightgray;" class="flex_col">
            <div *ngFor="let unit_amount_step of unitAmountSteps" class="unit_amount_step" [style.bottom]="unit_amount_step.percentage + '%'">
              <div>{{unit_amount_step.description}}</div>
              <div style="width: 14px; height: 0;"></div>
            </div>
          </div>
          <div class="flex_row" style="position:relative;">
            <ng-container *ngFor="let bar of bars">
              <div *ngIf="barIsShown(bar)" class="bar">
                <div class="sub_bar" *ngFor="let percentages of bar.percentages"
                     [tooltip]="$any(barTooltipTemplate)" contentType="template"
                     [ngStyle]="{
                     'bottom': percentages.from_percent + '%',
                     'top': (100 - percentages.to_percent) + '%',
                     'background-color': (percentages.style || bar.data.style) == 'filled' ? percentages.color : 'transparent',
                   }"
                     [style.border]="'2px solid '+ percentages.color + '!important'"
                     (click)="clickBarEvent.emit(bar.data.external_idx >= 0 ? bar.data.external_idx : bars.indexOf(bar))"
                >
                  <fa-icon class="bar_icon" *ngIf="percentages.icon" [icon]="percentages.icon"></fa-icon>

                  <ng-template #barTooltipTemplate>
                    <div style="text-align: left;" *ngIf="percentages.tooltip.infos?.length">
                      <h6>Info</h6>
                      <ul>
                        <li *ngFor="let info of percentages.tooltip.infos">
                          {{info}}
                        </li>
                      </ul>
                    </div>
                    <div style="text-align: left;" *ngIf="percentages.tooltip.errors?.length">
                      <h6>Fehler</h6>
                      <ul>
                        <li *ngFor="let error of percentages.tooltip.errors">
                          {{error}}
                        </li>
                      </ul>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-container>

            <div *ngFor="let deadline of deadlines" class="deadline" style="border-width: 2px!important; right: -50px!important; z-index: 15;"
                 [style.bottom]="getDeadlinePercentage(deadline) + '%'"
                 [style.color]="deadline.color"
                 [style.border-color]="deadline.color + '!important'"
            >
              <div *ngIf="deadline.description" class="deadline_description">
                {{deadline.description}}
              </div>
            </div>

            <div *ngFor="let unit_amount_step of unitAmountSteps" class="deadline" style="left: -14px;"
                 [style.bottom]="unit_amount_step.percentage + '%'">
            </div>

          </div>
        </div>
        </div>
        <div class="bars-names-container">
          <ng-container *ngFor="let bar of bars">
            <div *ngIf="barIsShown(bar)" class="bar-name-slot">
              <div class="bar_description">{{bar.description}}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
